import { render } from "./AppStageHeader.vue?vue&type=template&id=9825d11c&scoped=true"
import script from "./AppStageHeader.vue?vue&type=script&lang=js"
export * from "./AppStageHeader.vue?vue&type=script&lang=js"

import "./AppStageHeader.vue?vue&type=style&index=0&id=9825d11c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9825d11c"

export default script